<template>
  <div :class="['program-template', isProgramEdit && 'program-edit']" v-show="temVisible" style="height: 100%;">
    <div class="header flex-b-c">
      <div class="header-left">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          active-text-color="#409EFF">

          <el-menu-item :index="screen.type + ''" v-for="screen in screenList"
            :key="screen.id">{{ screen.name }}</el-menu-item>
          <!-- <el-menu-item index="2">竖屏</el-menu-item>
          <el-menu-item index="3">LED</el-menu-item>
          <el-menu-item index="4">LCD</el-menu-item> -->
          <!-- <el-menu-item index="5" v-if="isProgramEdit">我的</el-menu-item> -->
        </el-menu>
      </div>
      <div class="header-right" v-if="!isProgramEdit">
        <el-button type="primary" @click="addTheme" size="mini" round>{{ $t('nstm10') }}</el-button>
      </div>
    </div>
    <div class="main-content">
      <Theme :themeList="themeList" @editTheme="handleEditTheme" v-loading="themeListLoading" @tempEdit="handleTempEdit"
        @openTemAdd="openTemAdd" @tempDelete="handleTempDelete" :themeType="1" @openDelDialog="openDelDialog"
        :isProgramEdit="isProgramEdit" @loadMore="loadMore" @uploadSuccess="uploadSuccess" :s_type="s_type">
      </Theme>
    </div>
    <theme-add :themeDialog="themeDialogVisible" :type="1" :addEdit="themeAddEdit" :editData="themeEditData"
      @closeThemeDialog="closeThemeDialog">
    </theme-add>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="delCloseDialog" :title="$t('nstm09')">
      <div class="dd-dialog">{{ $t('nstm08') }}</div>
    </del-dialog>
    <del-dialog :dialogVisible="tempDelVisible" @closeDialog="tempDelCloseDialog" :title="$t('nstm12')">
      <div class="dd-dialog">{{ $t('nstm11') }}</div>
    </del-dialog>
  </div>
</template>

<script>
import DelDialog from '@/components/basics/DelDialog'
import Theme from '../children/Theme'
import ThemeAdd from '../children/ThemeAdd'

export default {
  name: 'ProgramTemplate',
  props: {
    temVisible: {
      type: Boolean,
      default: true
    },
    isProgramEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: '1',
      DelDialogVisible: false,
      tempDelVisible: false,
      OpenTemAdd: false,
      themeList: [],
      addThemeId: 0, // 当前新增模板的主题id
      themeAddEdit: 'ADD',
      themeDialogVisible: false,
      themeEditData: {},
      themeDelId: 0,
      tempAddEdit: 'ADD',
      tempEditData: {},
      screenList: [],
      s_type: 1,
      themeListLoading: false
    }
  },
  created() {
    this.getScreenList();
  },
  methods: {
    getScreenList() {
      this.$http.post('/admin/template/getScreenList', {}, (res) => {
        this.screenList = res;
        this.s_type = res[0].type
        this.getThemeList();
      })
    },
    handleSelect(key) {
      this.activeIndex = key;
      this.s_type = parseInt(key);
      this.getThemeList();
    },
    delCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post('/admin/template/deleteTheme', {
          ids: this.themeDelId,
        }, () => {
          this.getThemeList();
        })
      }
      this.DelDialogVisible = false;
    },
    // 获取主题列表
    getThemeList() {
      this.themeListLoading = true;
      const screen_type = (this.activeIndex === "1" || this.activeIndex === "2") ? +this.activeIndex : 0;
      const screen_orientation = (this.activeIndex === "3" || this.activeIndex === "4") ? +this.activeIndex - 2 : 0;
      const self = this.activeIndex === "5" ? 1 : 0;
      this.$http.post('/admin/template/getThemeList', {
        group_ids: this.$cookies.get('group_ids'),
        s_type: this.s_type,
        type: 1,
        screen_type,
        screen_orientation,
        self
      }, data => {
        this.themeList = data || [];
        this.themeListLoading = false;
      })
    },
    loadMore(page, themeId) {
      this.themeListLoading = true;
      const screen_type = (this.activeIndex === "1" || this.activeIndex === "2") ? +this.activeIndex : 0;
      const screen_orientation = (this.activeIndex === "3" || this.activeIndex === "4") ? +this.activeIndex - 2 : 0;
      const self = this.activeIndex === "5";
      this.$http.post('/admin/template/list', {
        group_ids: this.$cookies.get('group_ids'),
        screen_type,
        screen_orientation,
        self,
        page,
        theme_id: themeId
      }, data => {
        const themeIndex = this.themeList.findIndex(item => item.id === themeId);
        if (data.data.length) {
          this.themeList[themeIndex].templates.splice(this.themeList[themeIndex].templates.length, 0, ...data.data);
        }
      })
    },
    uploadSuccess() {
      this.getThemeList();
    },
    addTheme() {
      this.themeAddEdit = 'ADD';
      this.themeDialogVisible = true;
    },
    closeThemeDialog(isUpdate) {
      this.themeDialogVisible = false;
      isUpdate && this.getThemeList();
    },
    handleEditTheme(theme) {
      this.themeAddEdit = 'EDIT';
      this.themeEditData = {
        id: theme.id,
        name: theme.name,
        description: theme.description,
      }
      this.themeDialogVisible = true;
    },
    closeTemAdd(isUpdate) {
      this.OpenTemAdd = false;
      isUpdate && this.getThemeList();
    },
    handleTempEdit(temp) {
      this.tempAddEdit = 'EDIT';
      this.tempEditData = temp;
      this.OpenTemAdd = true;
    },
    openTemAdd(id) {
      this.tempAddEdit = 'ADD';
      this.addThemeId = id;
      this.OpenTemAdd = true;
    },
    handleTempDelete(id) {
      this.tempDelId = id;
      this.tempDelVisible = true;
    },
    tempDelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post('/admin/template/delTemplate', {
          ids: this.tempDelId,
        }, data => {
          console.log(data);
          this.getThemeList();
          this.tempDelVisible = false;
        })
      }
      this.tempDelVisible = false;
    },
    openDelDialog(id) {
      this.DelDialogVisible = true;
      this.themeDelId = id
    },
  },
  components: {
    Theme,
    ThemeAdd,
    DelDialog,
  }
}
</script>

<style lang="scss" scoped>
.program-edit {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: absolute;
  left: 0;
  top: 0;
  background-color: white;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(240, 240, 240, 1);
  }
}

.header {
  width: 100%;
  height: 60px;

  .header-left {
    margin-left: 20px;
    display: flex;
    justify-content: flex-start;

    .el-menu-demo {
      /deep/.el-menu-item {
        height: 48px;
        line-height: 48px;
      }
    }
  }

  .header-right {
    margin-right: 20px;
  }
}

.main-content {
  height: calc(100% - 80px);
  padding: 0 20px;
  overflow: auto;
}
</style>